import { render, staticRenderFns } from "./navigation-menu-user.vue?vue&type=template&id=ecb32906&scoped=true&"
import script from "./navigation-menu-user.vue?vue&type=script&lang=js&"
export * from "./navigation-menu-user.vue?vue&type=script&lang=js&"
import style0 from "./navigation-menu-user.vue?vue&type=style&index=0&id=ecb32906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb32906",
  null
  
)

export default component.exports